import React, { useEffect, useState } from "react";
import supabase from "../supabaseClient";
import "../pages/Settings.css"; // New CSS file

const Settings = () => {
  const [carwash, setCarwash] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saveSuccess, setSaveSuccess] = useState(false);

  useEffect(() => {
    const fetchCarwash = async () => {
      const {
        data: { user },
      } = await supabase.auth.getUser();

      const { data, error } = await supabase
        .from("carwashes")
        .select("*")
        .eq("user_id", user.id)
        .single();

      if (error) {
        console.error("Error fetching carwash:", error);
      } else {
        setCarwash(data);
      }

      setLoading(false);
    };

    fetchCarwash();
  }, []);

  const handleChange = (field, value) => {
    setCarwash((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    setSaveSuccess(false);

    const { error } = await supabase
      .from("carwashes")
      .update({
        name: carwash.name,
        phone: carwash.phone,
        open_time: carwash.open_time,
        close_time: carwash.close_time,
        active_status: carwash.active_status,
        isOpen: carwash.isOpen,
      })
      .eq("id", carwash.id);

    setSaving(false);

    if (error) {
      console.error(error);
    } else {
      setSaveSuccess(true);
      setTimeout(() => setSaveSuccess(false), 3000);
    }
  };

  if (loading)
    return <div className="loading-spinner">Loading settings...</div>;

  if (!carwash)
    return (
      <div className="empty-state">
        <p>No car wash found for your account.</p>
      </div>
    );

  return (
    <div className="settings">
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Location Settings</h3>
          <p className="card-subtitle">
            Manage your car wash details and operating hours
          </p>
        </div>

        <div className="settings-grid">
          <div className="settings-section">
            <h4 className="section-title">Basic Information</h4>
            <div className="input-group">
              <label>Car Wash Name</label>
              <input
                type="text"
                value={carwash.name || ""}
                onChange={(e) => handleChange("name", e.target.value)}
                placeholder="My Car Wash"
              />
            </div>

            <div className="input-group">
              <label>Contact Phone</label>
              <input
                type="text"
                value={carwash.phone || ""}
                onChange={(e) => handleChange("phone", e.target.value)}
                placeholder="+1 (555) 123-4567"
              />
            </div>
          </div>

          <div className="settings-section">
            <h4 className="section-title">Operating Hours</h4>
            <div className="time-inputs">
              <div className="input-group">
                <label>Open Time</label>
                <input
                  type="time"
                  value={carwash.open_time || ""}
                  onChange={(e) => handleChange("open_time", e.target.value)}
                />
              </div>

              <div className="input-group">
                <label>Close Time</label>
                <input
                  type="time"
                  value={carwash.close_time || ""}
                  onChange={(e) => handleChange("close_time", e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="settings-section">
            <h4 className="section-title">Operation Status</h4>
            <div className="toggle-group">
              <label className="toggle-item">
                <input
                  type="checkbox"
                  checked={carwash.active_status}
                  onChange={(e) =>
                    handleChange("active_status", e.target.checked)
                  }
                />
                <span className="toggle-label">Business Active</span>
                <span className="toggle-description">
                  Enable to allow customer check-ins
                </span>
              </label>

              <label className="toggle-item">
                <input
                  type="checkbox"
                  checked={carwash.isOpen}
                  onChange={(e) => handleChange("isOpen", e.target.checked)}
                />
                <span className="toggle-label">Currently Open</span>
                <span className="toggle-description">
                  Toggle when you're serving customers
                </span>
              </label>
            </div>
          </div>
        </div>

        <div className="settings-actions">
          <button
            onClick={handleSave}
            disabled={saving}
            className="button button-primary"
          >
            {saving ? (
              <>
                <span className="spinner"></span>
                Saving...
              </>
            ) : (
              "Save Changes"
            )}
          </button>
          {saveSuccess && (
            <div className="save-success">
              <span>✓</span> Settings saved successfully!
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Settings;
